import React from 'react'

import { Icon } from "@material-ui/core";
import PrimaryTheme from '../Themes/Primary';
import { useDispatch, useSelector } from 'react-redux';
import { Reducers } from "../Interfaces/Interfaces";
import { getCurrency, getDateTime } from '../helpers/Functions';


export default function TransactionDetailsStatus(props: any) {

    const transactionsDetailsStatus = useSelector(
        (state: Reducers) => state.transactionDetailsStatusReducer
    );
    const transactionDetailsMessageReducer = useSelector(
        (state: any) => state.transactionDetailsMessageReducer
    );

// console.log({sessionId:transactionDetailsMessageReducer.sessionId})
    const dispatch = useDispatch()

    return (
        <div className=" col-lg-8 container" style={{ paddingBottom: "30px" }}>
            <div className="card shadow p-3" style={{ border: "none" }}>
                <div className="card-body">
                    <div style={{ fontSize: PrimaryTheme.fontSizes?.title, width: "100%", textAlign: "center", fontWeight: 500 }}>
                        SYSTEM TRANSACTION DETAILS
                    </div>
                    <div>
                        <div style={{ width: "100%", textAlign: "center", fontSize: PrimaryTheme.fontSizes?.small }}>The details below show the final transaction status known to Bankly from our partners</div>
                        <div className="container col-8" style={{ height: "10px", marginTop: "10px", background: PrimaryTheme.primary, borderRadius: "26px", marginBottom: "30px" }}></div>
                        <div className="col-11 container">
                            <div className="row" style={{ paddingTop: "10px", paddingBottom: "10px", paddingLeft: "10px", paddingRight: "10px" }}>
                                <div className="col-6" style={{ textAlign: "right" }}>
                                    {
                                        props.transactionTypeChoose === "Bill Payment" ? "STATUS" : " STATUS"
                                    }
                                </div>
                                <div className="col-6">{props.transactionTypeChoose === "Bill Payment" ? transactionsDetailsStatus.status==="Success"?<span style={{backgroundColor:"green",color:"white"}}>{transactionsDetailsStatus.status}</span> :transactionsDetailsStatus.status: transactionsDetailsStatus.statusName==="Success"?<span style={{backgroundColor:"green",color:"white"}}>{transactionsDetailsStatus.statusName}</span> :transactionsDetailsStatus.statusName}</div>
                            </div>
                            <div style={{ paddingTop: "10px", paddingBottom: "10px", background: "#F4F7FC", paddingLeft: "10px", paddingRight: "10px" }} className="row">
                                <div className="col-6" style={{ textAlign: "right" }}>{props.transactionTypeChoose === "Bill Payment" ? "TOKEN" : "RESPONSE CODE"}</div>
                                <div className="col-6">{
                                    props.transactionTypeChoose === "Bill Payment" ? transactionsDetailsStatus.isTokenType ? transactionsDetailsStatus.billToken : "N/A" : transactionsDetailsStatus.responseCode

                                }</div>
                            </div>
                            <div style={{ paddingTop: "10px", paddingBottom: "10px", paddingLeft: "10px", paddingRight: "10px" }} className="row">
                                <div className="col-6" style={{ textAlign: "right" }}>
                                    {
                                        props.transactionTypeChoose === "Bill Payment" ? "BILL TYPE" : "NIBSS SESSION ID"
                                    }
                                </div>
                                <div className="col-6">{
                                    props.transactionTypeChoose === "Bill Payment" ? transactionsDetailsStatus.billTypeName : transactionDetailsMessageReducer.sessionId ?transactionDetailsMessageReducer.sessionId : "N/A"
                                }</div>
                            </div>
                            <div style={{ paddingTop: "10px", paddingBottom: "10px", background: "#F4F7FC", paddingLeft: "10px", paddingRight: "10px" }} className="row">
                                <div className="col-6" style={{ textAlign: "right" }}>REFERENCE</div>
                                <div className="col-6">{

                                    props.transactionTypeChoose === "Bill Payment" ? transactionsDetailsStatus.paymentReference :
                                        transactionsDetailsStatus.responseReference
                                }</div>
                            </div>
                            <div style={{ paddingTop: "10px", paddingBottom: "10px", paddingLeft: "10px", paddingRight: "10px" }} className="row">
                                <div className="col-6" style={{ textAlign: "right" }}>TIME</div>
                                <div className="col-6">{
                                    props.transactionTypeChoose === "Bill Payment" ? getDateTime(transactionsDetailsStatus.paidOn) :
                                        getDateTime(transactionsDetailsStatus.dateCreated)

                                }</div>
                            </div>
                            <div style={{ paddingTop: "10px", paddingBottom: "10px", background: "#F4F7FC", paddingLeft: "10px", paddingRight: "10px" }} className="row">
                                <div className="col-6" style={{ textAlign: "right" }}>AMOUNT</div>
                                <div className="col-6">{
                                    props.transactionTypeChoose === "Bill Payment" ? getCurrency(transactionsDetailsStatus.billAmount) :
                                        getCurrency(transactionsDetailsStatus.amountToSend)
                                }</div>
                            </div>
                        </div>
                        {
                            transactionDetailsMessageReducer.message ? <div style={{ width: "100%" }}>
                                <div style={{ fontSize: PrimaryTheme.fontSizes?.title, width: "100%", textAlign: "center", fontWeight: 500, marginTop: "30px" }}>
                                    BANKLY FEEDBACK
                                </div>
                                <div style={{ width: "100%", textAlign: "center", fontSize: PrimaryTheme.fontSizes?.small }}>{transactionDetailsMessageReducer.message}</div>
                            </div>
                                : ""
                        }


                        {/* <div style={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
                           
                            <div style={{ width: "100%" }}>
                                <button
                                    className="btn btn-link text-secondary"
                                    onClick={() => dispatch({ type: "ALERT_MODAL", payload: true })}
                                >
                                    <div className="row m-0 align-items-center" style={{
                                        color: PrimaryTheme.light,
                                    }}>
                                        <Icon
                                            style={{
                                                marginRight: 5,

                                            }}
                                        >
                                            download
                                        </Icon>
                                        Escalate to Bankly
                                    </div>
                                </button>
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>
        </div>
    )
}
